/* global videojs */
import helpers from './helpers';

const VideoTypes = {
	MP4: 'video/mp4',
	X_MPEG: 'application/x-mpegURL',
};

const getVideoType = (src) => {
	if (src.includes('mp4')) {
		return VideoTypes.MP4;
	}

	if (src.includes('m3u8')) {
		return VideoTypes.X_MPEG;
	}
};

let players = [];

const initVideo = (page) => {
	const isMobile = helpers.isMobile();

	$(page).find('.video-js').each((index, item) => {
		const $video = $(item);
		const $parent = $video.parent();

		let player = $parent.data('player');
		let video10secInterval = null;
		let isPlayed = false;

		const name = $video.data('name');
		const src = $video.data('src');

		if (player) {
			return;
		}

		const videoPoster = item.dataset.poster;

		player = videojs(item, {
			poster: videoPoster,
			autoplay: false,
			muted: true,
			controls: false,
			loop: false,
			// aspectRatio: '16:9',
			playsinline: true,
			preload: 'auto',
		});

		player.src({
			src,
			type: getVideoType(src),
			withCredentials: true,
		});
		// player.play();
		// player.pause();
		$parent.data('player', player);

		player.on('play', () => {
			if (!$parent.find('.video-js').hasClass('is-playing')) {
				if (isMobile) {
					player.requestFullscreen();
					player.play();
				}
				$parent.find('.js-video-play').fadeOut();
				$parent.find('.video-js').addClass('is-playing');
			}

			if (!isPlayed) {
				helpers.$document.trigger('video-first-click', [name]);

				isPlayed = true;
			}

			clearInterval(video10secInterval);

			helpers.$document.trigger('video-play', [name]);

			video10secInterval = setInterval(() => {
				helpers.$document.trigger('video-10-sec', [name]);
			}, 10000);
		});

		player.on('exitFullscreen', () => {
			// console.log('exitFullscreen');
		});
		player.on('pause', () => {
			clearInterval(video10secInterval);
		});
		player.on('ended', () => {
			helpers.$document.trigger('video-end', [name]);
			if (isMobile) {
				player.exitFullscreen();
				// player.play();
			}
			clearInterval(video10secInterval);
		});

		helpers.$document.on('videoStop', () => {
			player.pause();
			player.currentTime(0);
		});

		players.push(player);

		// objectFitVideos();
	});
};

// setTimeout(() => {
// 	initVideo('.site');
// }, 1000);

export {initVideo};
